import { useGlobalStore } from '../context/global';

const ProgressBar = () => {
  const [globalState] = useGlobalStore();
  const { active = false, value = 0, label = '' } = globalState.progress || {};

  if (!active) return '';

  return (
    <header className="extra-info relative">
      <div className="relative h-6 py-0.5 overflow-hidden text-sm font-semibold leading-5 text-center text-white bg-[#3498db]">
        <div className="absolute inset-y-0 left-0 progress-fill transition-all" style={{ width: `${value}%` }} />
        <span className="relative">{label}{label && ' '}{Math.round(value)}%</span>
      </div>
    </header>
  );
};

export default ProgressBar;
